import React from 'react';
import { Box } from '@tanium/react-box';
import { css } from '@tanium/react-emotion';
import { Icon } from '@tanium/react-graphics';
import { Link } from '@tanium/react-link';
import { useRouter } from '@tanium/react-router';
import { Stack, StackChild } from '@tanium/react-stack';
import { ThemeFontWeights } from '@tanium/theme-data';
import { LinkIconFill, LinkText } from './themeDefinitions';

const blockStyle = css({
  display: 'block',
});
export interface WelcomeLink {
  /**
   * The icon to display for the link.
   */
  icon?: Icon;
  /**
   * The text to display for the link.
   */
  text: string;
  /**
   * The URL to navigate to. Relative links will be handled internally by the router.
   */
  href: string;
}

interface WelcomeLinksProps {
  links: WelcomeLink[];
}

export const WelcomeLinks = ({ links }: WelcomeLinksProps) => {
  const { isInternalRoute } = useRouter();

  return (
    <Stack itemDividers itemSpacing={4} flexWrap="wrap" mb={-1}>
      {links.map(({ text, href, icon: IconComponent }) => (
        <StackChild mb={1} key={text}>
          <Link href={href} target={isInternalRoute(href) ? undefined : '_blank'}>
            <Stack itemSpacing={1} alignItems="center">
              {IconComponent && (
                <Box color={LinkIconFill}>
                  <IconComponent height={14} width={14} focusable={false} className={blockStyle} />
                </Box>
              )}
              <Box fontWeight={ThemeFontWeights.Bold} color={LinkText} fontSize="14px">
                {text}
              </Box>
            </Stack>
          </Link>
        </StackChild>
      ))}
    </Stack>
  );
};
